<template>
  <div>
    <link href="https://api.mapbox.com/mapbox-gl-js/v3.1.2/mapbox-gl.css" rel="stylesheet">
    <link
      rel="stylesheet"
      href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"
    >

    <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC" crossorigin="anonymous">

    <div id="dashboard" class="dashboard-container">
      <el-row
        :gutter="20"
        class="dashboard-row"
        style="background: #fff; padding: 16px 16px 0; height: 670px; margin-bottom: 5px;"
      >
        <!-- <el-row :gutter="20">
          <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
            <div class="card-panel">
              <div class="card-panel-description">
                <div class="card-panel-text">
                  <b style="color: #00ab53">
                    <count-to
                      :start-val="0"
                      :end-val="coordonnees_size"
                      :duration="2600"
                      class="card-panel-num"
                    />
                    Registrations géolocalisées
                  </b>
                  <br><br>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
            <el-autocomplete
              v-show="showIlotSearchInput"
              v-model="selectedIlot"
              :fetch-suggestions="null"
              placeholder="Rechercher un ilot avec son numéro"
              clearable
              :popper-class="'autocomplete-popper'"
              @change="getIlotRegistrationsGeoJson"
            >
              <template slot-scope="{ item }">
                <span>{{ item.ilot }}</span>
              </template>
            </el-autocomplete>
          </el-col>
          <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
            <el-autocomplete
              v-show="showRegistrationSearchInput"
              v-model="selectedRegistration"
              :fetch-suggestions="null"
              placeholder="Rechercher une registration avec son numéro"
              clearable
              :popper-class="'autocomplete-popper'"
              @change="getSelectedRegistrationGeoJson"
            >
              <template slot-scope="{ item }">
                <span>{{ item.properties['Numéro registration'] }}</span>
              </template>
            </el-autocomplete>
          </el-col>
        </el-row> -->
        <el-row :gutter="24">
          <el-col :xs="12" :sm="12" :lg="5" class="card-panel-col">
            <div v-show="showProvinces">
              <label for="province-filter" class="filter-label">{{ $t('province.provinces') }}:</label>
              <br>
              <el-select
                id="province-filter"
                v-model="selectedProvince"
                class="filter-item"
                filterable
                clearable
                :placeholder="$t('general.search')"
                @change="handleFilterProvince"
              >
                <el-option
                  v-for="(province, index) in provinces"
                  :key="index"
                  :label="province.name | uppercaseFirst"
                  :value="province"
                />
              </el-select>
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :lg="5" class="card-panel-col">
            <div v-show="showDepartments">
              <label for="department-filter" class="filter-label">{{ $t('department.departments') }}:</label>
              <br>
              <el-select
                id="department-filter"
                v-model="selectedDepartment"
                class="filter-item"
                filterable
                clearable
                :placeholder="$t('general.search')"
                @change="handleFilterDepartment"
              >
                <el-option
                  v-for="(department, index) in departments"
                  :key="index"
                  :label="department.name | uppercaseFirst"
                  :value="department"
                />
              </el-select>
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :lg="5" class="card-panel-col">
            <div v-show="showMunicipalities">
              <label for="municipality-filter" class="filter-label">{{ $t('municipality.municipalities') }}:</label>
              <br>
              <el-select
                id="municipality-filter"
                v-model="selectedMunicipality"
                class="filter-item"
                filterable
                clearable
                :placeholder="$t('general.search')"
                @change="handleFilterMunicipality"
              >
                <el-option
                  v-for="(municipality, index) in municipalities"
                  :key="index"
                  :label="municipality.name | uppercaseFirst"
                  :value="municipality"
                />
              </el-select>
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :lg="5" class="card-panel-col">
            <div v-show="showVillages">
              <label for="village-filter" class="filter-label">{{ $t('village.villages') }}:</label>
              <br>
              <el-select
                id="village-filter"
                v-model="selectedVillage"
                class="filter-item"
                filterable
                clearable
                :placeholder="$t('general.search')"
                @change="handleFilterVillage"
              >
                <el-option
                  v-for="(village, index) in villages"
                  :key="index"
                  :label="village.name | uppercaseFirst"
                  :value="village.name"
                />
              </el-select>
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :lg="4" class="card-panel-col">
            <div v-show="showRegistrationSearchInput">
              <label for="registration-filter" class="filter-label">{{ $t('dashboard.registration') }}:</label>
              <br>
              <el-select
                id="registration-filter"
                v-model="selectedRegistration"
                class="filter-item"
                filterable
                clearable
                :placeholder="$t('general.search')"
                @change="handleFilterRegistration"
              >
                <el-option
                  v-for="(registration, index) in registrations"
                  :key="index"
                  :label="registration.properties.ref | uppercaseFirst"
                  :value="registration.properties.id"
                />
              </el-select>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :xs="12" :sm="12" :lg="6" class="card-panel-text">
            <b style="color: #00ab53;">
              <count-to
                :start-val="0"
                :end-val="coordonnees_size"
                :duration="2600"
                class="card-panel-num"
              />
              {{ $t('dashboard.localisedRegistration') }}
            </b>
          </el-col>
          <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
            <el-button type="primary" icon="el-icon-refresh" style="float: right;" @click="voirCarte()">
              {{ $t('dashboard.refresh') }}
            </el-button>
          </el-col>
          <el-col :xs="12" :sm="12" :lg="8" class="card-panel-col">
            <div class="btn-group" role="group" aria-label="Basic radio toggle button group" style="float: right;">
              <input id="streets" v-model="selectedStyle" type="radio" class="btn-check" value="streets-v12" @change="switchStyle('streets-v12')">
              <label for="streets" class="btn btn-outline-primary">{{ $t('dashboard.streetView') }}</label>
              <input id="satellite" v-model="selectedStyle" type="radio" class="btn-check" value="satellite-v9" @change="switchStyle('satellite-v9')">
              <label for="satellite" class="btn btn-outline-primary">{{ $t('dashboard.satelliteView') }}</label>
            </div>
          </el-col>
        </el-row>
        <div id="mapContainer" style="width: 100%; height: 500px" />
      </el-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Resource from '@/api/resource';
import Swal from 'sweetalert2';
import waves from '@/directive/waves';
import permission from '@/directive/permission';
import role from '@/directive/role';
// import checkPermission from '@/utils/permission';
// import checkRole from '@/utils/role';
import mapboxgl from 'mapbox-gl';
import CountTo from 'vue-count-to';
import customMarker from '@/assets/marquer.png';
// import { mapActions } from 'vuex';
// import { EventBus } from '@/eventBus';
import * as turf from '@turf/turf';
import limitesAdmin from '@/assets/tchad_admin3.json';
const mapResource = new Resource('dashboard');

export default {
  name: 'Map',
  directives: {
    waves,
    permission,
    role,
  },
  components: {
    CountTo,
  },
  data() {
    return {
      loading: false,
      accessToken: 'pk.eyJ1IjoiZGV2b25lc295IiwiYSI6ImNsMTR0c2Y0MDBkdWIzZHF6cjk5OWJ1NnMifQ.cEu2E93WCC2rY74DEjqixg',
      coordonnees: [],
      coordonnees_size: 0,
      selectedRegistration: {},
      coordonneesAffichees: [],
      registrations: [],
      showIlotSearchInput: false,
      showRegistrationSearchInput: false,
      selectedStyle: 'streets-v12',
      query: {
        page: 1,
        limit: 5000,
        keyword: '',
        province_id: '',
        municipality_id: '',
        village_id: '',
        department_id: '',
      },

      provinces: [],
      municipalities: [],
      villages: [],
      departments: [],
      allProvinces: [],
      allMunicipalities: [],
      allVillages: [],
      allDepartments: [],
      showProvinces: false,
      showMunicipalities: false,
      showVillages: false,
      showDepartments: false,
      selectedProvince: null,
      selectedMunicipality: null,
      selectedVillage: null,
      selectedDepartment: null,
    };
  },
  computed: {
    ...mapGetters([
    //  'userId',
      'id',
      'name',
      'email',
      'avatar',
    //  'device',
    ]),
  },
  mounted() {
    // this.fetchGeoJsonData();
  },
  created() {
    this.handleGeoJsonData();
  },
  methods: {
    // checkPermission,
    // checkRole,
    // ...mapActions(['fetchTierDetails']),
    handleGeoJsonData() {
      this.fetchGeoJsonData(); // Assurez-vous que cette méthode est bien définie
    },
    async fetchGeoJsonData() {
      this.coordonnees = await mapResource.sublist('/registrations-coordinates-geojson', this.query);
      this.coordonneesAffichees = this.coordonnees;
      this.provinces = this.coordonnees.provinces;
      this.municipalities = this.coordonnees.municipalities;
      this.villages = this.coordonnees.villages;
      this.departments = this.coordonnees.departments;
      this.registrations = this.coordonnees.features;
      this.allDepartments = this.departments;
      this.allProvinces = this.provinces;
      this.allMunicipalities = this.municipalities;
      this.allVillages = this.villages;
      this.showRegistrationSearchInput = true;
      this.voirCarte();
      this.showProvinces = true;
    },
    switchStyle(style){
      this.selectedStyle = style;
      this.voirCarte();
    },

    voirCarte(selectedCoordonnees = null) {
      this.coordonnees_size = this.coordonneesAffichees.features.length;
      console.log('this.coordonneesAffichees', this.coordonnees_size);

      mapboxgl.accessToken = this.accessToken;

      // Vérification si `coordonneesAffichees` est vide
      if (!this.coordonneesAffichees.features || this.coordonneesAffichees.features.length === 0) {
        Swal.fire(
          'Vide!',
          'Aucune coordonnée à afficher sur la carte.',
          'info'
        );
        return;
      }

      // Coordonnées du centre du Tchad (environ)
      const defaultCenter = [18.7322, 15.4542]; // [longitude, latitude]

      /* if (this.coordonneesAffichees.features.length > 0) {
        const firstFeature = this.coordonneesAffichees.features.find(feature =>
          feature.geometry.type === 'Point'
        );

        if (firstFeature) {
          defaultCenter = firstFeature.geometry.coordinates;
        }
      } */

      var map = new mapboxgl.Map({
        container: 'mapContainer',
        style: `mapbox://styles/mapbox/${this.selectedStyle}`,
        center: selectedCoordonnees || defaultCenter,
        zoom: 4,
      });

      const points = [];
      this.coordonneesAffichees.features.forEach(registration => {
        if (registration.geometry.type === 'Point') {
          points.push(registration);
        }
      });

      map.on('load', () => {
        map.loadImage(customMarker, (error, image) => {
          if (error) {
            throw error;
          }
          map.addImage('custom-marker', image);

          // Ajout des points
          if (points.length > 0) {
            map.addSource('points', {
              type: 'geojson',
              data: {
                type: 'FeatureCollection',
                features: points,
              },
            });

            /* map.addLayer({
              id: 'points-layer',
              type: 'symbol',
              source: 'points',
              layout: {
                'icon-image': 'custom-marker',
                'icon-size': 0.6,
                'text-field': ['get', 'Numéro registration'],
                'text-offset': [0, 1.25],
                'text-anchor': 'top',
              },
            }); */
            map.addLayer({
              'id': 'points-layer',
              'type': 'circle',
              'source': 'points',
              'paint': {
                'circle-color': '#00ab53',
                'circle-radius': 6,
                'circle-stroke-width': 3,
                'circle-stroke-color': '#FFBA00',
              },
            });

            // Ajout du popup pour les points
            const pointPopup = new mapboxgl.Popup({
              closeButton: true,
              closeOnClick: true,
            });

            map.on('click', 'points-layer', (e) => {
              const coordinates = e.lngLat;
              const properties = e.features[0].properties;

              pointPopup.setLngLat(coordinates)
                .setHTML(`
                <span>${this.$t('village.village')}: ${properties['village'] || ''}</span><br/>
                <span>${this.$t('municipality.municipality')}: ${properties['municipality'] || ''}</span><br/>
                <span>${this.$t('department.department')}: ${properties['department'] || ''}</span><br/>
                <span>${this.$t('province.province')}: ${properties['province'] || ''}</span>
                `)
                .addTo(map);
            });

            map.on('mouseleave', 'points-layer', () => {
              pointPopup.remove();
            });
          }

          // === AJOUT DES LIMITES ADMINISTRATIVES ===
          map.addSource('limites-admin', {
            type: 'geojson',
            data: limitesAdmin,
          });

          // Calque des bordures
          map.addLayer({
            id: 'limites-line',
            type: 'line',
            source: 'limites-admin',
            layout: {},
            paint: {
              'line-color': '#003366',
              'line-width': 1.2,
            },
          });

          // Calque de remplissage (avec état "hover")
          map.addLayer({
            id: 'limites-fill',
            type: 'fill',
            source: 'limites-admin',
            layout: {},
            paint: {
              'fill-color': '#0088ff',
              'fill-opacity': [
                'case',
                ['boolean', ['feature-state', 'hover'], false],
                0.4, // survol
                0.1, // normal
              ],
            },
          });

          // Calque de texte (nom des régions)
          map.addLayer({
            id: 'limites-labels',
            type: 'symbol',
            source: 'limites-admin',
            layout: {
              'text-field': ['get', 'name_1'],
              'text-size': 12,
              'text-anchor': 'center',
            },
            paint: {
              'text-color': '#002244',
            },
          });

          // === SURVOL ET COMPTAGE DYNAMIQUE DES CAS ===
          let hoveredId = null;
          const infoPopup = new mapboxgl.Popup({
            closeButton: false,
            closeOnClick: false,
            className: 'info-popup',
          });

          map.on('mousemove', 'limites-fill', (e) => {
            if (e.features.length === 0) {
              return;
            }
            const feature = e.features[0];

            // Met à jour l’état hover visuel
            if (hoveredId) {
              map.setFeatureState({ source: 'limites-admin', id: hoveredId }, { hover: false });
            }
            hoveredId = feature.id;
            map.setFeatureState({ source: 'limites-admin', id: hoveredId }, { hover: true });

            // Récupère le polygone de la région survolée
            const polygon = feature.geometry;

            // Filtrer les points de maladie qui se trouvent à l'intérieur de la zone
            const pointsWithin = turf.pointsWithinPolygon(
              {
                type: 'FeatureCollection',
                features: points, // les points de ta couche "points"
              },
              polygon
            );

            const nombreCas = pointsWithin.features.length;
            const nomRegion = feature.properties.name_1 || 'Zone inconnue';

            // Affiche une popup dynamique au survol
            infoPopup
              .setLngLat(e.lngLat)
              .setHTML(`<strong>${nomRegion}</strong><br/>Cas enregistrés : <b>${nombreCas}</b>`)
              .addTo(map);
          });

          map.on('mouseleave', 'limites-fill', () => {
            if (hoveredId) {
              map.setFeatureState({ source: 'limites-admin', id: hoveredId }, { hover: false });
            }
            hoveredId = null;
            infoPopup.remove();
          });
          // === FIN SURVOL ET COMPTAGE DYNAMIQUE DES CAS ===
        });
      });

      map.addControl(new mapboxgl.FullscreenControl());
      map.addControl(new mapboxgl.NavigationControl(), 'top-right');
      map.addControl(new mapboxgl.GeolocateControl({
        positionOptions: { enableHighAccuracy: true },
        trackUserLocation: true,
      }), 'top-right');

      if (selectedCoordonnees != null) {
        map.flyTo({
          center: selectedCoordonnees,
          essential: true,
          zoom: 15,
          speed: 2,
          curve: 1,
          easing(t) {
            return t;
          },
        });
      }
    },
    getSelectedRegistrationGeoJson(id) {
      console.log('slectedRegistration', id);

      const registration = this.coordonnees.find(parc => parc.properties['id'] === id);
      this.registrationsAffichees = {
        'type': 'FeatureCollection',
        'features': [registration],
      };
      this.voirCarte();
    },
    handleFilterRegistration(id) {
      this.query.page = 1;
      const registration = this.registrations.filter(registration => registration.properties.id === id);
      this.coordonneesAffichees = {
        'type': 'FeatureCollection',
        'features': registration,
      };
      this.voirCarte();
    },
    handleFilterVillage(name) {
      this.showRegistrationSearchInput = false;
      this.query.page = 1;
      const village = this.coordonnees.features.filter(parc => parc.properties['village'] === name);
      this.coordonneesAffichees = {
        'type': 'FeatureCollection',
        'features': village,
      };
      this.voirCarte();
      this.registrations = village;
      this.showRegistrationSearchInput = true;
    },
    handleFilterMunicipality(municipality) {
      this.showVillages = false;
      this.query.page = 1;
      this.showRegistrationSearchInput = false;
      const municipalityData = this.coordonnees.features.filter(parc => parc.properties['municipality'] === municipality.name);
      this.coordonneesAffichees = {
        'type': 'FeatureCollection',
        'features': municipalityData,
      };
      this.voirCarte();
      const villageIds = new Set(municipality.villages.map(v => v.id));
      this.villages = this.allVillages.filter(vil => villageIds.has(vil.id));
      this.showVillages = true;
      this.registrations = municipalityData;
      this.showRegistrationSearchInput = true;
    },
    handleFilterDepartment(department) {
      this.showMunicipalities = false;
      this.showVillages = false;
      this.showRegistrationSearchInput = false;
      this.query.page = 1;
      const departmentData = this.coordonnees.features.filter(parc => parc.properties['department'] === department.name);
      this.coordonneesAffichees = {
        'type': 'FeatureCollection',
        'features': departmentData,
      };
      this.voirCarte();

      const municipalityIds = new Set(department.municipalities.map(m => m.id));
      this.municipalities = this.allMunicipalities.filter(mun => municipalityIds.has(mun.id));
      this.showMunicipalities = true;
      this.registrations = departmentData;
      this.showRegistrationSearchInput = true;
    },
    handleFilterProvince(province) {
      this.showDepartments = false;
      this.showMunicipalities = false;
      this.showVillages = false;
      this.showRegistrationSearchInput = false;
      this.query.page = 1;
      const provinceData = this.coordonnees.features.filter(parc => parc.properties['province'] === province.name);
      this.coordonneesAffichees = {
        'type': 'FeatureCollection',
        'features': provinceData,
      };
      this.voirCarte();
      console.log('provinceData', provinceData);

      const departmentIds = new Set(province.departments.map(d => d.id));
      this.departments = this.allDepartments.filter(dep => departmentIds.has(dep.id));
      this.showDepartments = true;
      this.registrations = provinceData;
      this.showRegistrationSearchInput = true;
    },
  },
};
</script>

<style scoped>
.mapboxgl-popup {
    max-width: 400px;
    font: 12px/20px 'Helvetica Neue', Arial, Helvetica, sans-serif;
}

.dashboard-editor-container {
    padding: 32px;
    background-color: rgb(240, 242, 245);

    .chart-wrapper {
        background: #fff;
        padding: 16px 16px 0;
        margin-bottom: 32px;
    }
}

.basemap {
    height: 400px;
}

#mapContainer {
    height: 100%;
    width: 100%;
}

.mapboxgl-canvas {
    width: 70vh !important;
    height: auto !important;
}

.btn-control {
    font: bold 12px/20px 'Helvetica Neue', Arial, Helvetica, sans-serif;
    background-color: #3386c0;
    color: #fff;
    position: absolute;
    top: 20px;
    left: 50%;
    z-index: 1;
    border: none;
    width: 200px;
    margin-left: -100px;
    display: block;
    cursor: pointer;
    padding: 10px 20px;
    border-radius: 3px;
}

.btn-control-simple {
    background-color: #3386c0;
    color: #fff;
    z-index: 1;
    border: none;
    cursor: pointer;
    height: 40px;
    border-radius: 3px;
}

.btn-control:hover {
    background-color: #4ea0da;
}

.mapboxgl-popup {
    max-width: 400px;
    font: 12px/20px 'Helvetica Neue', Arial, Helvetica, sans-serif;
}
</style>
